import {
  WorkplaceRequestElement,
  WorkplaceRequestTypeElement
} from "@gettactic/api";

export interface WorkplaceRequestReserveFormData {
  id: string | undefined;
  type: WorkplaceRequestTypeElement;
  title: string;
  description: string;
  isDeleted: boolean;
  originalData: WorkplaceRequestElement;
}

export const mapWorkplaceRequestToReserveFormData = (
  workplaceRequests: WorkplaceRequestElement[],
  types: WorkplaceRequestTypeElement[],
  includeIds = true
): WorkplaceRequestReserveFormData[] => {
  return workplaceRequests.map((req) => {
    const type = types.find((t) => t.id === req.type.id);
    return {
      id: includeIds ? req.id : undefined,
      isNew: !includeIds,
      type: type || {
        id: req.type.id,
        name: "Unknown Type",
        description: "",
        in_use: false,
        llm_context: "",
        assigned_users: []
      },
      title: req.title,
      description: req.description,
      isDeleted: false,
      originalData: req
    };
  });
};
